import { http } from '@frontend/fetch';

type Connection = {
  locationID: string;
  sourceID: string;
  connectionID: string;
  clientVersion: string;
};

type SyncAppConnectionResponse = {
  data: { connections: Connection[] };
};

const syncAppConnectionsUrl = 'support/v1/syncapp/connections';

// LocationId should be the parent location id in case of multi-location
export const getSyncAppConnection = (sourceId: string, locationId: string) =>
  http.get<SyncAppConnectionResponse>(syncAppConnectionsUrl, {
    params: { sourceID: sourceId },
    headers: { 'Location-Id': locationId },
  });
